import { render, staticRenderFns } from "./canvas.vue?vue&type=template&id=3ee05a14"
import script from "./canvas.vue?vue&type=script&lang=ts"
export * from "./canvas.vue?vue&type=script&lang=ts"
import style0 from "./canvas.vue?vue&type=style&index=0&id=3ee05a14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports